import { capabilities, Capability, type Zeitraum } from '../../../../../../dtos';
import { type CalendarEvent } from '../../../../ResourceCalendar';
import {
  isExperteEvent,
  isSeminarraumEvent,
  isStandortEvent,
} from '../../../../ResourceCalendar/helperClasses/CalendarEvent/CalendarEvent';
import { calendarEventStates } from '../../../../ResourceCalendar/helperClasses/CalendarEvent/calendarEventStates';
import { content } from './ActionButtons.content';

export function getSaveButtonState(
  isSaving: boolean,
  isOnlineThema: boolean,
  ablauf: readonly Zeitraum[],
  withResources: boolean,
  selectedCalendarEvents: readonly Pick<CalendarEvent, 'type' | 'state'>[],
  vaCapabilities?: Capability[],
): {
  isSaveButtonDisabled: boolean;
  tooltip: string | null;
} {
  const raumStandortSelectionExists = selectedCalendarEvents.some(
    (event) => isSeminarraumEvent(event) || isStandortEvent(event),
  );
  const experteSelectionExists = selectedCalendarEvents.some(isExperteEvent);
  const erroneousSelectionExists = selectedCalendarEvents.some((event) => event.state === calendarEventStates.ERROR);

  if (isSaving) {
    return { isSaveButtonDisabled: true, tooltip: content.tooltips.processing };
  }

  if (erroneousSelectionExists) {
    return { isSaveButtonDisabled: true, tooltip: content.tooltips.errorInSelection };
  }

  if (!withResources) {
    if (ablauf.length === 0) {
      return { isSaveButtonDisabled: true, tooltip: content.tooltips.missingStartDate };
    }

    return { isSaveButtonDisabled: false, tooltip: null };
  }

  if (isOnlineThema && !experteSelectionExists) {
    return { isSaveButtonDisabled: true, tooltip: content.tooltips.missingExpert };
  }

  if (
    !isOnlineThema &&
    ((!experteSelectionExists && !raumStandortSelectionExists) ||
      (!raumStandortSelectionExists && vaCapabilities?.includes(capabilities.SELECT_STANDORT)))
  ) {
    return { isSaveButtonDisabled: true, tooltip: content.tooltips.missingResourceSelection };
  }

  return { isSaveButtonDisabled: false, tooltip: null };
}
